import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "./about";

export const Route = createFileRoute("/about-us")({
  head: () => ({
    meta: [
      {
        title: "About Us — KMWAdvertising LLP",
      },
      {
        name: "description",
        content: "With over 25 years of experience in advertising, media planning, and creative strategy.",
      },
    ],
  }),
  component: AboutPage,
});
